import { render, staticRenderFns } from "./SingleSelectionAutocomplete.vue?vue&type=template&id=55e3930c"
import script from "./SingleSelectionAutocomplete.vue?vue&type=script&lang=js"
export * from "./SingleSelectionAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports